function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "wifi"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12 21c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.551 0-1 .448-1 1s.449 1 1 1 1-.448 1-1-.449-1-1-1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m15.299 13.99c-.19 0-.382-.054-.552-.167-1.625-1.076-3.869-1.076-5.494 0-.46.306-1.082.18-1.386-.28-.305-.46-.18-1.081.281-1.386 2.282-1.514 5.423-1.514 7.705 0 .46.305.586.926.281 1.386-.193.29-.511.447-.835.447z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m18.16 11.13c-.217 0-.435-.07-.619-.215-1.59-1.253-3.506-1.915-5.541-1.915s-3.951.662-5.541 1.915c-.433.343-1.062.268-1.405-.166-.342-.434-.267-1.063.167-1.404 1.946-1.534 4.29-2.345 6.779-2.345s4.833.811 6.779 2.345c.434.342.508.971.167 1.404-.198.25-.491.381-.786.381z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21 8.29c-.228 0-.457-.077-.645-.235-2.334-1.97-5.3-3.055-8.355-3.055s-6.021 1.085-8.355 3.055c-.421.355-1.052.301-1.409-.119-.357-.423-.303-1.054.119-1.41 2.694-2.274 6.119-3.526 9.645-3.526s6.951 1.252 9.645 3.526c.422.355.476.986.119 1.409-.198.234-.48.355-.764.355z"
})));

var Svg132Wifi = function Svg132Wifi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg132Wifi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/132-wifi.5aab5127.svg";
export { ForwardRef as ReactComponent };